import { Component } from 'react'
import { IS_STATUS_APP } from 'helpers/userAgentHelpers'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { logOutActionCreator } from 'actions/authActions'
import { connect } from 'react-redux'

type LoginLinkDispatchProps = {
  onClick: () => void
}

type LoginLinkOwnProps = {
  search?: string
}

type LoginLinkProps =
  & LoginLinkDispatchProps
  & LoginLinkOwnProps

class LoginLink extends Component<LoginLinkProps> {
  render () {
    const { search, children } = this.props

    if (IS_STATUS_APP) {
      return (
        <a onClick={ this.props.onClick }>
          { children }
        </a>
      )
    } else {
      return (
        <NavigationLink search={ search } to='login'>
          { children }
        </NavigationLink>
      )
    }
  }
}

const mapDispatchToProps: LoginLinkDispatchProps = {
  // transition to Login pages occurs on logout
  // TODO Native app
  onClick: () => logOutActionCreator({ redirect: false }),
}

const LoginLinkContainer = connect<
  {}, LoginLinkDispatchProps, LoginLinkOwnProps
>(undefined, mapDispatchToProps)(LoginLink)

export default LoginLinkContainer
